__turbopack_context__.v({
  "icon": "HowToPlay-module__X_QxNG__icon",
  "list": "HowToPlay-module__X_QxNG__list",
  "prizeBannerRow": "HowToPlay-module__X_QxNG__prizeBannerRow",
  "text": "HowToPlay-module__X_QxNG__text",
});
